import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { User, Music, Calendar, DollarSign, FileText, Activity, AlertTriangle, CheckCircle, Edit, MoreHorizontal, ShieldCheck, Link as LinkIcon, Download, Eye, CalendarOff, Plane, X, Plus, Clock, ChevronLeft, ChevronRight } from 'lucide-react';
import { useParams, Link } from 'react-router-dom';
const TABS = ['Overview', 'Availability', 'Acts', 'Compensation', 'Documents', 'Activity'];
export function MemberDetailPage() {
  const {
    artistId,
    memberId
  } = useParams();
  const [activeTab, setActiveTab] = useState('Overview');
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} className="space-y-6" data-id="element-3778">
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-4" data-id="element-3779">
        <div data-id="element-3780">
          <div className="flex items-center space-x-3 mb-2" data-id="element-3781">
            <h1 className="text-2xl font-bold text-zinc-100" data-id="element-3782">Sarah Williams</h1>
            <span className="px-2.5 py-1 bg-green-500/10 text-green-500 text-xs font-medium rounded-full border border-green-500/20 flex items-center" data-id="element-3783">
              <CheckCircle className="w-3 h-3 mr-1" data-id="element-3784" />
              Available
            </span>
          </div>
          <div className="flex items-center space-x-4 text-zinc-400 text-sm" data-id="element-3785">
            <span className="flex items-center" data-id="element-3786">
              <Music className="w-4 h-4 mr-1" data-id="element-3787" /> Violin / Fiddle / BGV
            </span>
            <span className="flex items-center" data-id="element-3788">
              <User className="w-4 h-4 mr-1" data-id="element-3789" /> Touring Member
            </span>
          </div>
          <div className="flex gap-2 mt-3" data-id="element-3790">
            <span className="px-2 py-1 bg-zinc-900 border border-zinc-800 rounded text-xs text-zinc-300" data-id="element-3791">
              Neon Dreams
            </span>
            <span className="px-2 py-1 bg-zinc-900 border border-zinc-800 rounded text-xs text-zinc-300" data-id="element-3792">
              The Midnight Echo
            </span>
          </div>
        </div>
        <div className="flex items-center space-x-3" data-id="element-3793">
          <button className="px-4 py-2 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-100 text-sm font-medium rounded-lg transition-colors flex items-center" data-id="element-3794">
            <Calendar className="w-4 h-4 mr-2" data-id="element-3795" />
            View Schedule
          </button>
          <button className="px-4 py-2 bg-amber-500 hover:bg-amber-400 text-zinc-900 text-sm font-medium rounded-lg transition-colors" data-id="element-3796">
            Request Confirmation
          </button>
          <button className="p-2 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-400 rounded-lg transition-colors" data-id="element-3797">
            <MoreHorizontal className="w-4 h-4" data-id="element-3798" />
          </button>
        </div>
      </div>

      {/* Tabs */}
      <div className="flex space-x-1 border-b border-zinc-800 overflow-x-auto no-scrollbar" data-id="element-3799">
        {TABS.map(tab => <button key={tab} onClick={() => setActiveTab(tab)} className={`px-4 py-2 text-sm font-medium whitespace-nowrap border-b-2 transition-colors ${activeTab === tab ? 'border-amber-500 text-amber-500' : 'border-transparent text-zinc-400 hover:text-zinc-100 hover:border-zinc-700'}`} data-id="element-3800">
            {tab}
          </button>)}
      </div>

      {/* Tab Content */}
      {activeTab === 'Overview' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3801">
          <div className="lg:col-span-2 space-y-6" data-id="element-3802">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3803">
              <div className="flex justify-between items-start mb-4" data-id="element-3804">
                <h3 className="text-lg font-medium text-zinc-100" data-id="element-3805">
                  Member Summary
                </h3>
                <button className="text-zinc-500 hover:text-zinc-300" data-id="element-3806">
                  <Edit className="w-4 h-4" data-id="element-3807" />
                </button>
              </div>
              <div className="grid grid-cols-2 gap-6" data-id="element-3808">
                <div data-id="element-3809">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3810">Primary Location</p>
                  <p className="text-zinc-300" data-id="element-3811">Nashville, TN</p>
                </div>
                <div data-id="element-3812">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3813">
                    Travel Preferences
                  </p>
                  <p className="text-zinc-300" data-id="element-3814">
                    Prefers flying for &gt; 6h drives
                  </p>
                </div>
                <div data-id="element-3815">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3816">
                    Dietary Restrictions
                  </p>
                  <p className="text-zinc-300" data-id="element-3817">Vegetarian</p>
                </div>
                <div data-id="element-3818">
                  <p className="text-sm text-zinc-500 mb-1" data-id="element-3819">Passport Status</p>
                  <p className="text-zinc-300 flex items-center" data-id="element-3820">
                    Valid (Exp. 2028){' '}
                    <ShieldCheck className="w-4 h-4 text-green-500 ml-2" data-id="element-3821" />
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3822">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3823">
                Upcoming Shows
              </h3>
              <div className="space-y-3" data-id="element-3824">
                {[{
              date: 'Jun 14',
              city: 'Cleveland, OH',
              act: 'Neon Dreams',
              status: 'Confirmed'
            }, {
              date: 'Jun 15',
              city: 'Detroit, MI',
              act: 'Neon Dreams',
              status: 'Confirmed'
            }, {
              date: 'Jul 02',
              city: 'Chicago, IL',
              act: 'The Midnight Echo',
              status: 'Pending'
            }].map((show, i) => <div key={i} className="flex items-center justify-between p-3 bg-zinc-900/50 rounded-lg border border-zinc-800/50" data-id="element-3825">
                    <div className="flex items-center space-x-4" data-id="element-3826">
                      <div className="text-sm font-medium text-zinc-300 w-12" data-id="element-3827">
                        {show.date}
                      </div>
                      <div data-id="element-3828">
                        <div className="text-sm font-medium text-zinc-100" data-id="element-3829">
                          {show.city}
                        </div>
                        <div className="text-xs text-zinc-500" data-id="element-3830">{show.act}</div>
                      </div>
                    </div>
                    <span className={`text-xs font-medium px-2 py-1 rounded-full ${show.status === 'Confirmed' ? 'bg-green-500/10 text-green-500' : 'bg-amber-500/10 text-amber-500'}`} data-id="element-3831">
                      {show.status}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-3832">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3833">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3834">
                Current Conflicts
              </h3>
              <div className="flex items-start space-x-3 p-3 bg-red-500/10 border border-red-500/20 rounded-lg" data-id="element-3835">
                <AlertTriangle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-3836" />
                <div data-id="element-3837">
                  <p className="text-sm font-medium text-red-500" data-id="element-3838">
                    Double Booked: Jul 02
                  </p>
                  <p className="text-xs text-red-400/80 mt-1" data-id="element-3839">
                    Neon Dreams (Chicago) vs The Midnight Echo (Milwaukee)
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3840">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3841">
                Recent Requests
              </h3>
              <div className="space-y-4" data-id="element-3842">
                <div className="flex justify-between items-center" data-id="element-3843">
                  <div className="text-sm" data-id="element-3844">
                    <p className="text-zinc-100" data-id="element-3845">Fall Tour 2026</p>
                    <p className="text-zinc-500 text-xs" data-id="element-3846">Sent 2 days ago</p>
                  </div>
                  <span className="text-xs text-amber-500" data-id="element-3847">Awaiting Reply</span>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {activeTab === 'Availability' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3848">
          <div className="lg:col-span-2 space-y-6" data-id="element-3849">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3850">
              <div className="flex justify-between items-center mb-6" data-id="element-3851">
                <h3 className="text-lg font-medium text-zinc-100" data-id="element-3852">June 2026</h3>
                <div className="flex items-center space-x-2" data-id="element-3853">
                  <button className="p-1.5 text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-3854">
                    <ChevronLeft className="w-4 h-4" data-id="element-3855" />
                  </button>
                  <button className="p-1.5 text-zinc-500 hover:text-zinc-300 transition-colors" data-id="element-3856">
                    <ChevronRight className="w-4 h-4" data-id="element-3857" />
                  </button>
                </div>
              </div>
              <div className="grid grid-cols-7 gap-2 text-center mb-2" data-id="element-3858">
                {['S', 'M', 'T', 'W', 'T', 'F', 'S'].map((day, i) => <div key={i} className="text-xs font-medium text-zinc-500" data-id="element-3859">
                    {day}
                  </div>)}
              </div>
              <div className="grid grid-cols-7 gap-2" data-id="element-3860">
                {Array.from({
              length: 30
            }).map((_, i) => {
              const day = i + 1;
              const isShow = day === 14 || day === 15;
              const isConflict = day === 2; // Jul 2nd in mock, but we'll show it here for effect
              const isBlackout = day >= 20 && day <= 22;
              return <div key={i} className={`aspect-square rounded-lg border flex flex-col items-center justify-center relative group cursor-pointer transition-colors ${isShow ? 'bg-green-500/10 border-green-500/20 text-green-500' : isConflict ? 'bg-red-500/10 border-red-500/20 text-red-500' : isBlackout ? 'bg-zinc-800/50 border-zinc-700/50 text-zinc-500' : 'bg-zinc-900/30 border-zinc-800/50 text-zinc-300 hover:border-zinc-600'}`} data-id="element-3861">
                      <span className="text-sm font-medium" data-id="element-3862">{day}</span>
                      {isShow && <div className="w-1.5 h-1.5 rounded-full bg-green-500 mt-1" data-id="element-3863"></div>}
                      {isConflict && <div className="w-1.5 h-1.5 rounded-full bg-red-500 mt-1" data-id="element-3864"></div>}
                      {isBlackout && <div className="w-1.5 h-1.5 rounded-full bg-zinc-600 mt-1" data-id="element-3865"></div>}
                    </div>;
            })}
              </div>
            </div>
          </div>

          <div className="space-y-6" data-id="element-3866">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3867">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3868">
                Connected Calendars
              </h3>
              <div className="flex items-center justify-between p-3 bg-zinc-900/50 border border-zinc-800/50 rounded-lg" data-id="element-3869">
                <div className="flex items-center space-x-3" data-id="element-3870">
                  <div className="w-8 h-8 rounded-full bg-blue-500/10 flex items-center justify-center" data-id="element-3871">
                    <Calendar className="w-4 h-4 text-blue-500" data-id="element-3872" />
                  </div>
                  <div data-id="element-3873">
                    <p className="text-sm font-medium text-zinc-100" data-id="element-3874">
                      Google Calendar
                    </p>
                    <p className="text-xs text-zinc-500" data-id="element-3875">sarah.w@gmail.com</p>
                  </div>
                </div>
                <span className="text-xs font-medium text-green-500 bg-green-500/10 px-2 py-1 rounded-full" data-id="element-3876">
                  Synced
                </span>
              </div>
            </div>

            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3877">
              <div className="flex justify-between items-start mb-4" data-id="element-3878">
                <h3 className="text-lg font-medium text-zinc-100" data-id="element-3879">
                  Blackout Dates
                </h3>
                <button className="text-zinc-500 hover:text-zinc-300" data-id="element-3880">
                  <Plus className="w-4 h-4" data-id="element-3881" />
                </button>
              </div>
              <div className="space-y-3" data-id="element-3882">
                <div className="flex items-center justify-between p-3 bg-zinc-900/50 border border-zinc-800/50 rounded-lg" data-id="element-3883">
                  <div className="flex items-center space-x-3" data-id="element-3884">
                    <CalendarOff className="w-4 h-4 text-zinc-500" data-id="element-3885" />
                    <div data-id="element-3886">
                      <p className="text-sm font-medium text-zinc-300" data-id="element-3887">
                        Family Vacation
                      </p>
                      <p className="text-xs text-zinc-500" data-id="element-3888">Jun 20 - Jun 22</p>
                    </div>
                  </div>
                  <button className="text-zinc-500 hover:text-red-500 transition-colors" data-id="element-3889">
                    <X className="w-4 h-4" data-id="element-3890" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {activeTab === 'Acts' && <div className="bg-[#14141A] border border-zinc-800 rounded-xl overflow-hidden" data-id="element-3891">
          <div className="p-4 border-b border-zinc-800 flex justify-between items-center bg-zinc-900/30" data-id="element-3892">
            <h3 className="font-medium text-zinc-100" data-id="element-3893">Linked Acts</h3>
            <button className="px-3 py-1.5 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-100 text-sm font-medium rounded-lg transition-colors" data-id="element-3894">
              Link Act
            </button>
          </div>
          <table className="w-full text-left text-sm" data-id="element-3895">
            <thead className="bg-zinc-900/50 border-b border-zinc-800 text-zinc-400" data-id="element-3896">
              <tr data-id="element-3897">
                <th className="px-4 py-3 font-medium" data-id="element-3898">Act Name</th>
                <th className="px-4 py-3 font-medium" data-id="element-3899">Role</th>
                <th className="px-4 py-3 font-medium" data-id="element-3900">Status</th>
                <th className="px-4 py-3 font-medium" data-id="element-3901">Joined</th>
                <th className="px-4 py-3 font-medium text-right" data-id="element-3902">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-zinc-800" data-id="element-3903">
              <tr className="hover:bg-zinc-900/50 transition-colors" data-id="element-3904">
                <td className="px-4 py-3 font-medium text-zinc-100 flex items-center" data-id="element-3905">
                  <Music className="w-4 h-4 mr-2 text-zinc-500" data-id="element-3906" /> Neon Dreams
                </td>
                <td className="px-4 py-3 text-zinc-400" data-id="element-3907">Violin / BGV</td>
                <td className="px-4 py-3" data-id="element-3908">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-green-500/10 text-green-500" data-id="element-3909">
                    Active
                  </span>
                </td>
                <td className="px-4 py-3 text-zinc-500" data-id="element-3910">Jan 2024</td>
                <td className="px-4 py-3 text-right" data-id="element-3911">
                  <button className="text-amber-500 hover:text-amber-400 text-xs font-medium" data-id="element-3912">
                    Manage Role
                  </button>
                </td>
              </tr>
              <tr className="hover:bg-zinc-900/50 transition-colors" data-id="element-3913">
                <td className="px-4 py-3 font-medium text-zinc-100 flex items-center" data-id="element-3914">
                  <Music className="w-4 h-4 mr-2 text-zinc-500" data-id="element-3915" /> The Midnight
                  Echo
                </td>
                <td className="px-4 py-3 text-zinc-400" data-id="element-3916">Session Strings</td>
                <td className="px-4 py-3" data-id="element-3917">
                  <span className="px-2 py-1 rounded-full text-xs font-medium bg-blue-500/10 text-blue-500" data-id="element-3918">
                    Touring Only
                  </span>
                </td>
                <td className="px-4 py-3 text-zinc-500" data-id="element-3919">Mar 2025</td>
                <td className="px-4 py-3 text-right" data-id="element-3920">
                  <button className="text-amber-500 hover:text-amber-400 text-xs font-medium" data-id="element-3921">
                    Manage Role
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>}

      {activeTab === 'Compensation' && <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-3922">
          <div className="lg:col-span-2 space-y-6" data-id="element-3923">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3924">
              <div className="flex justify-between items-start mb-6" data-id="element-3925">
                <div data-id="element-3926">
                  <h3 className="text-lg font-medium text-zinc-100" data-id="element-3927">
                    Default Compensation Rules
                  </h3>
                  <p className="text-sm text-zinc-400 mt-1" data-id="element-3928">
                    Base rates applied to new shows.
                  </p>
                </div>
                <button className="text-zinc-500 hover:text-zinc-300" data-id="element-3929">
                  <Edit className="w-4 h-4" data-id="element-3930" />
                </button>
              </div>
              <div className="grid grid-cols-2 gap-6" data-id="element-3931">
                <div className="p-4 bg-zinc-900/50 border border-zinc-800/50 rounded-lg" data-id="element-3932">
                  <div className="text-sm text-zinc-500 mb-1" data-id="element-3933">
                    Show Guarantee
                  </div>
                  <div className="text-xl font-medium text-zinc-100" data-id="element-3934">$250</div>
                  <div className="text-xs text-zinc-500 mt-1" data-id="element-3935">
                    Per performance
                  </div>
                </div>
                <div className="p-4 bg-zinc-900/50 border border-zinc-800/50 rounded-lg" data-id="element-3936">
                  <div className="text-sm text-zinc-500 mb-1" data-id="element-3937">Per Diem</div>
                  <div className="text-xl font-medium text-zinc-100" data-id="element-3938">$40</div>
                  <div className="text-xs text-zinc-500 mt-1" data-id="element-3939">
                    Per travel/show day
                  </div>
                </div>
                <div className="p-4 bg-zinc-900/50 border border-zinc-800/50 rounded-lg" data-id="element-3940">
                  <div className="text-sm text-zinc-500 mb-1" data-id="element-3941">Merch Split</div>
                  <div className="text-xl font-medium text-zinc-100" data-id="element-3942">0%</div>
                  <div className="text-xs text-zinc-500 mt-1" data-id="element-3943">
                    Not included in merch gross
                  </div>
                </div>
                <div className="p-4 bg-zinc-900/50 border border-zinc-800/50 rounded-lg" data-id="element-3944">
                  <div className="text-sm text-zinc-500 mb-1" data-id="element-3945">
                    Rehearsal Rate
                  </div>
                  <div className="text-xl font-medium text-zinc-100" data-id="element-3946">$100</div>
                  <div className="text-xs text-zinc-500 mt-1" data-id="element-3947">Per day</div>
                </div>
              </div>
            </div>

            <div className="bg-[#14141A] border border-zinc-800 rounded-xl overflow-hidden" data-id="element-3948">
              <div className="p-4 border-b border-zinc-800 flex justify-between items-center bg-zinc-900/30" data-id="element-3949">
                <h3 className="font-medium text-zinc-100" data-id="element-3950">
                  Upcoming Expected Payouts
                </h3>
              </div>
              <table className="w-full text-left text-sm" data-id="element-3951">
                <thead className="bg-zinc-900/50 border-b border-zinc-800 text-zinc-400" data-id="element-3952">
                  <tr data-id="element-3953">
                    <th className="px-4 py-3 font-medium" data-id="element-3954">Date</th>
                    <th className="px-4 py-3 font-medium" data-id="element-3955">Show / Event</th>
                    <th className="px-4 py-3 font-medium" data-id="element-3956">Amount</th>
                    <th className="px-4 py-3 font-medium" data-id="element-3957">Status</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-zinc-800" data-id="element-3958">
                  <tr className="hover:bg-zinc-900/50 transition-colors" data-id="element-3959">
                    <td className="px-4 py-3 text-zinc-400" data-id="element-3960">Jun 14</td>
                    <td className="px-4 py-3 font-medium text-zinc-100" data-id="element-3961">
                      Cleveland, OH (Neon Dreams)
                    </td>
                    <td className="px-4 py-3 text-zinc-300" data-id="element-3962">$290</td>
                    <td className="px-4 py-3" data-id="element-3963">
                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-amber-500/10 text-amber-500" data-id="element-3964">
                        Pending Show
                      </span>
                    </td>
                  </tr>
                  <tr className="hover:bg-zinc-900/50 transition-colors" data-id="element-3965">
                    <td className="px-4 py-3 text-zinc-400" data-id="element-3966">Jun 15</td>
                    <td className="px-4 py-3 font-medium text-zinc-100" data-id="element-3967">
                      Detroit, MI (Neon Dreams)
                    </td>
                    <td className="px-4 py-3 text-zinc-300" data-id="element-3968">$290</td>
                    <td className="px-4 py-3" data-id="element-3969">
                      <span className="px-2 py-1 rounded-full text-xs font-medium bg-amber-500/10 text-amber-500" data-id="element-3970">
                        Pending Show
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div className="space-y-6" data-id="element-3971">
            <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3972">
              <h3 className="text-lg font-medium text-zinc-100 mb-4" data-id="element-3973">
                Payment Details
              </h3>
              <div className="space-y-4" data-id="element-3974">
                <div className="flex items-center justify-between p-3 bg-zinc-900/50 border border-zinc-800/50 rounded-lg" data-id="element-3975">
                  <div className="flex items-center space-x-3" data-id="element-3976">
                    <div className="w-8 h-8 rounded-full bg-zinc-800 flex items-center justify-center" data-id="element-3977">
                      <DollarSign className="w-4 h-4 text-zinc-400" data-id="element-3978" />
                    </div>
                    <div data-id="element-3979">
                      <p className="text-sm font-medium text-zinc-300" data-id="element-3980">
                        Direct Deposit
                      </p>
                      <p className="text-xs text-zinc-500" data-id="element-3981">
                        Checking •••• 4582
                      </p>
                    </div>
                  </div>
                  <span className="text-xs font-medium text-green-500 bg-green-500/10 px-2 py-1 rounded-full" data-id="element-3982">
                    Active
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {activeTab === 'Documents' && <div className="bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-3983">
          <div className="flex justify-between items-center mb-6" data-id="element-3984">
            <h3 className="text-lg font-medium text-zinc-100" data-id="element-3985">
              Member Documents
            </h3>
            <button className="flex items-center space-x-2 px-3 py-1.5 bg-zinc-900 border border-zinc-800 hover:bg-zinc-800 text-zinc-300 text-sm font-medium rounded-lg transition-colors" data-id="element-3986">
              <Plus className="w-4 h-4" data-id="element-3987" />
              <span data-id="element-3988">Upload Document</span>
            </button>
          </div>
          <div className="space-y-3" data-id="element-3989">
            {[{
          name: 'W-9 Form (2026)',
          type: 'PDF',
          size: '1.2 MB',
          date: 'Uploaded Jan 2026',
          status: 'Valid'
        }, {
          name: 'Touring Agreement - Neon Dreams',
          type: 'PDF',
          size: '3.4 MB',
          date: 'Signed Jan 2026',
          status: 'Signed'
        }, {
          name: 'Passport Copy',
          type: 'JPG',
          size: '2.1 MB',
          date: 'Uploaded Dec 2025',
          status: 'Valid'
        }].map((doc, i) => <div key={i} className="flex items-center justify-between p-4 bg-zinc-900/50 rounded-lg border border-zinc-800/50 hover:border-zinc-700 transition-colors group" data-id="element-3990">
                <div className="flex items-center space-x-4" data-id="element-3991">
                  <div className="p-2 bg-zinc-800 rounded-lg text-zinc-400" data-id="element-3992">
                    <FileText className="w-5 h-5" data-id="element-3993" />
                  </div>
                  <div data-id="element-3994">
                    <div className="font-medium text-zinc-100" data-id="element-3995">{doc.name}</div>
                    <div className="text-xs text-zinc-500" data-id="element-3996">
                      {doc.type} • {doc.size} • {doc.date}
                    </div>
                  </div>
                </div>
                <div className="flex items-center space-x-4" data-id="element-3997">
                  <span className="text-xs font-medium text-green-500 bg-green-500/10 px-2 py-1 rounded-full" data-id="element-3998">
                    {doc.status}
                  </span>
                  <div className="flex items-center space-x-2 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-3999">
                    <button className="p-2 text-zinc-400 hover:text-zinc-100 bg-zinc-800/50 hover:bg-zinc-800 rounded-lg transition-colors" data-id="element-4000">
                      <Download className="w-4 h-4" data-id="element-4001" />
                    </button>
                    <button className="p-2 text-zinc-400 hover:text-zinc-100 bg-zinc-800/50 hover:bg-zinc-800 rounded-lg transition-colors" data-id="element-4002">
                      <MoreHorizontal className="w-4 h-4" data-id="element-4003" />
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </div>}

      {activeTab === 'Activity' && <div className="max-w-2xl bg-[#14141A] border border-zinc-800 rounded-xl p-6" data-id="element-4004">
          <h3 className="text-lg font-medium text-zinc-100 mb-6" data-id="element-4005">
            Member Timeline
          </h3>
          <div className="space-y-6 relative before:absolute before:inset-0 before:ml-5 before:-translate-x-px md:before:mx-auto md:before:translate-x-0 before:h-full before:w-0.5 before:bg-gradient-to-b before:from-transparent before:via-zinc-800 before:to-transparent" data-id="element-4006">
            {[{
          icon: CheckCircle,
          title: 'Confirmed Availability',
          time: 'Yesterday, 10:30 AM',
          desc: 'Confirmed for Jun 14 & 15 shows',
          color: 'text-green-500',
          bg: 'bg-green-500/10'
        }, {
          icon: AlertTriangle,
          title: 'Conflict Flagged',
          time: '3 days ago',
          desc: 'Jul 02 double booking detected',
          color: 'text-red-500',
          bg: 'bg-red-500/10'
        }, {
          icon: DollarSign,
          title: 'Payout Processed',
          time: '1 week ago',
          desc: '$290 for May 28 show',
          color: 'text-amber-500',
          bg: 'bg-amber-500/10'
        }, {
          icon: FileText,
          title: 'Signed Touring Agreement',
          time: 'Jan 15, 2026',
          desc: 'Neon Dreams 2026 Agreement',
          color: 'text-blue-500',
          bg: 'bg-blue-500/10'
        }].map((item, i) => <div key={i} className="relative flex items-center justify-between md:justify-normal md:odd:flex-row-reverse group is-active" data-id="element-4007">
                <div className="flex items-center justify-center w-10 h-10 rounded-full border border-zinc-800 bg-[#14141A] text-zinc-500 shrink-0 md:order-1 md:group-odd:-translate-x-1/2 md:group-even:translate-x-1/2 shadow-[0_0_0_4px_#14141A] z-10" data-id="element-4008">
                  <div className={`p-1.5 rounded-full ${item.bg}`} data-id="element-4009">
                    <item.icon className={`w-4 h-4 ${item.color}`} data-id="element-4010" />
                  </div>
                </div>
                <div className="w-[calc(100%-4rem)] md:w-[calc(50%-2.5rem)] p-4 rounded-xl border border-zinc-800 bg-zinc-900/30" data-id="element-4011">
                  <div className="flex items-center justify-between mb-1" data-id="element-4012">
                    <h4 className="font-medium text-zinc-100 text-sm" data-id="element-4013">
                      {item.title}
                    </h4>
                  </div>
                  <p className="text-xs text-zinc-400 mb-2" data-id="element-4014">{item.desc}</p>
                  <time className="text-[10px] font-medium text-zinc-500" data-id="element-4015">
                    {item.time}
                  </time>
                </div>
              </div>)}
          </div>
        </div>}
    </motion.div>;
}